module.exports = __webpack_public_path__ + "static/media/phone-laptop.65f613fa.svg";